import { AnyFieldApi } from '@tanstack/react-form'

interface GetFieldErrorOptions {
  isSubmitted?: boolean
  requireTouched?: boolean
}

export const getFieldError = (
  field: AnyFieldApi,
  options?: GetFieldErrorOptions
): string | undefined => {
  const errors = field.state.meta.errors ?? []
  const isTouched = field.state.meta.isTouched
  const { isSubmitted = false, requireTouched = false } = options ?? {}

  if (errors.length === 0 || (requireTouched && !isTouched && !isSubmitted)) {
    return undefined
  }

  const messages = errors
    .map(error => (typeof error?.message === 'string' ? error.message : ''))
    .filter(Boolean)

  const uniqueMessages = Array.from(new Set(messages))

  if (uniqueMessages.length <= 1) {
    return uniqueMessages[0]
  }

  const bulletMessages = uniqueMessages.map(message => `⁃ ${message}`)
  return bulletMessages.join('\n')
}
